<div class="grid-outer-container">
  <div class="inner-container">
    <div class="loading-center">
      <div id="loadingMessage" class="section-h2 center" *ngIf="!logout">Logging in...</div>
      <div id="signingOutMessage" class="section-h2 center" *ngIf="logout">Signing out...</div>
      <div class="home-pg-loader cw-loader">
        <div class="cw-loader-line"></div>
      </div>
    </div>
  </div>
</div>
